import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { catchError, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';

import { DadosPrestadorService } from '../dados-prestador/dados-prestador.service';
import { GtoTokenComponent } from '../gto-token/gto-token.component';
import { GtoTokenService } from '../gto-token/gto-token.service';
import { AcaoCancelarComponent } from './acao-cancelar/acao-cancelar.component';
import { AcaoFinalizarComponent } from './acao-finalizar/acao-finalizar.component';
import { AcaoProrrogarComponent } from './acao-prorrogar/acao-prorrogar.component';
import { AcaoSalvarComponent } from './acao-salvar/acao-salvar.component';
import { AcoesService } from './acoes.service';


@Component({
  selector: 'app-acoes',
  templateUrl: './acoes.component.html',
  styleUrls: ['./acoes.component.css']
})
export class AcoesComponent implements OnInit, OnDestroy {

  @ViewChild('acaoCancelar')
  public acaoCancelar: AcaoCancelarComponent;

  @ViewChild('acaoProrrogar')
  public acaoProrrogar: AcaoProrrogarComponent;

  @ViewChild('acaoSalvar')
  public acaoSalvar: AcaoSalvarComponent;

  @ViewChild('acaoFinalizar')
  public acaoFinalizar: AcaoFinalizarComponent;

  @ViewChild('gtoToken')
  public gtoToken: GtoTokenComponent;

  @Input() gto;

  @Output() onAction = new EventEmitter();
  @Output() onActionFinalizar = new EventEmitter();

  private subs: Subscription[] = [];

  public acaoSelecionada: string;
  public enviaToken: string;
  public isLoadingImprimir = false;
  public tokenExigido: string;
  public tokenMensagem: string;

  constructor(
    private acoesService: AcoesService,
    private dadosPrestadorService: DadosPrestadorService,
    private gtoTokenService: GtoTokenService,
    private messageService: MessageService,
    private router: Router,
  ) { }

  private checkTokenEnabled$() {
    const buscarConfigsToken$ = this.acoesService.buscarConfigsToken();
    const buscarDadosPrestador$ = this.dadosPrestadorService.buscarDadosCadastrais();

    return forkJoin(buscarConfigsToken$, buscarDadosPrestador$).pipe(
      tap(([configsToken, dadosPrestador]) => {
        this.tokenMensagem = configsToken.data.tokenMensagem;
        this.tokenExigido = configsToken.data.tokenExigido;
        this.enviaToken = dadosPrestador.data.enviaToken;
      },
        errorResponse => {
          this.messageService.add({ severity: 'error', summary: 'Erro ao checar flags do token', detail: errorResponse.error.errors[0].message });
        })
    );
  }

  private isTokenEnabled() {
    return this.enviaToken === 'S' && this.tokenExigido === '1';
  }

  private hasTokenOrJustificativa(): boolean {
    return (this.gto.numeroToken || this.gto.nomeJustificativaToken) ? true : false;
  }

  private canOpenDialogFinalizar() {
    return this.isTokenEnabled() && !this.hasTokenOrJustificativa();
  }

  acaoCancelarDisplay() {
    return false;
  }

  ngOnInit() {
    this.isLoadingImprimir = false;
  }

  ngOnDestroy() {
    this.subs.forEach((subscription) => subscription.unsubscribe());
  }

  abrirDialogProrrogar() {
    this.acaoProrrogar.abrirDialog();
  }

  abrirDialogCancelar() {
    this.acaoCancelar.abrirDialog();
  }

  abrirDialogFinalizar(numeroGto: number) {
    this.onActionFinalizar.emit(true);
    this.subs.push(
      this.checkTokenEnabled$().pipe(
        tap(_ => {
          if (this.canOpenDialogFinalizar()) {
            this.onActionFinalizar.emit(false);
            this.gtoToken.openDialog();
          } else {
            this.onActionFinalizar.emit(false);
            this.acoesService.setCanGoToFinalizar(true);
            this.gtoTokenService.setCanOpenModalTokenOnFinalizar(false);
            this.router.navigate([`detalhagto/${numeroGto}/finalizar`]);
          }
        }),
        catchError(() => {
          this.onActionFinalizar.emit(false);
          return of(null);
        }),
      ).subscribe()
    );
  }

  abrirEditar(numeroGto) {
    this.router.navigate(['detalhagto', numeroGto], { queryParams: { edit: 1 } });
  }

  imprimir() {
    if (this.isLoadingImprimir) {
      return;
    }

    this.isLoadingImprimir = true;
    this.acoesService.imprimirGTO(this.gto.numero).subscribe(
      response => {
        this.isLoadingImprimir = false;
        window.open(response.data, '_blank');
      },
      error => {
        this.isLoadingImprimir = false;
        console.log('Não foi possível imprimir a GTO.');
      });
  }

  salvarGTO() {
    this.acaoSalvar.salvar();
  }

  callbackOnAction(event) {
    this.onAction.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/acoes/acoes.component.ts